exports = module.exports = require("../../../../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-size{\n    border-bottom: 1px solid #f3f3f3 !important;\n    font-size: 1.3rem;\n    color: #777777;\n}\n.text-custom{\n    color: #c3c3c3;\n}\n.btn-warning {\n    background-color: #f7cb52!important;\n}\n.border-radi{\n    border-radius: 10px 10px 10px 10px;\n}\n.imgProduct{\n    width: 70px;\n}\n@media (max-width:514px) {\n    .table-mobile{\n        min-width: 800px;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/product-list/view/listproduct/listproduct.component.css
// module id = ../../../../../src/app/admin/page/product-list/view/listproduct/listproduct.component.css
// module chunks = main